/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeCircleMOffIcon24Solid = forwardRef('ShapeCircleMOffIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.384 3.616a1.25 1.25 0 1 0-1.768 1.768l3.165 3.165a8 8 0 0 0 10.67 10.67l3.165 3.165a1.25 1.25 0 0 0 1.768-1.768l-17-17Z" }),
        React.createElement("path", { d: "M20 12a7.964 7.964 0 0 1-1.108 4.064L7.936 5.108A8 8 0 0 1 20 12Z" })));
});
